import DeviceAlarm from './device'
export default DeviceAlarm
